//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
import rule from './rule/index.vue';
import { whereGql, formatStr } from '@/graphql/util';
import { GetArticleList } from '@/api/audit';
import 'dayjs/locale/zh-cn';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import LocalizedFormat from 'dayjs/plugin/localizedFormat';
dayjs.locale('zh-cn');
dayjs.extend(relativeTime);
dayjs.extend(LocalizedFormat);
const white = [
  { key: 'sponsor_name', lable: '操作人', width: '100' },
  { key: 'product_name', lable: '产品' },
  { key: 'api_name', lable: '操作类型' },
  { key: 'request', lable: '接口请求', width: '320' },
  { key: 'action_name', lable: '操作行为' },
  { key: 'operand_name', lable: '操作对象' },
  { key: 'is_success', lable: '操作结果', width: '100' },
  { key: 'create_time', lable: '操作时间', width: '160' },
];
export default {
  components: {
    rule,
  },
  data() {
    return {
      appOptions: [], // 产品列表
      loading: false,
      white,
      searchForm: {
        sponsor: '',
        product_name: '',
        api_name: '',
        request: '',
        date: null,
      },
      list: [],
      page: 1,
      pageSize: 10,
      total: 0,
      dialogVisible: false,
      detail: {},
      // 规则
      showRule: false,
    };
  },
  computed: {
    ...mapGetters('user', ['getElementList']),
    jurisdiction() {
      const jurisdictionArray = ['auditLog_system_rule'];
      const jurisdictionObj = {};
      for (const item of jurisdictionArray) {
        jurisdictionObj[item] = this.getElementList.includes(item);
      }

      return jurisdictionObj;
    },
    getDetail() {
      return Object.keys(this.detail)
        .map((key) => {
          if (this.keys.includes(key)) {
            return;
          }
          return { key, value: this.detail[key] };
        })
        .filter((item) => {
          return item;
        });
    },
    keys() {
      return white.map((item) => {
        return item.key;
      });
    },
  },
  created() {
    this.getList();
    this.loadAppOption();
  },
  methods: {
    async loadAppOption() {
      try {
        const { data } = await this.$request({
          url: this.$api.getAppList,
          data: { page_size: 999999 },
        });
        this.appOptions = data;
      } catch (err) {
        console.log(err);
      }
    },
    humanifyDate(str) {
      return dayjs(str).format('YYYY-MM-DD HH:mm:ss');
    },
    getValue(val) {
      if (val === null) {
        return '';
      }
      switch (typeof val) {
        case 'string':
          return `${val}`;
        case 'boolean':
          return val ? 'true' : 'false';
        case 'number':
          return `${val}`;
        case 'undefined':
          return '';
        default:
          return JSON.stringify(val);
      }
    },
    searchList() {
      this.page = 1;
      this.getList();
    },
    resetForm() {
      this.page = 1;
      this.searchForm = {
        sponsor: '',
        product_name: '',
        api_name: '',
        request: '',
        date: null,
      };
      this.getList();
    },
    async getList() {
      this.loading = true;
      try {
        // 筛选处理
        let filterArr = [];

        if (this.searchForm.date) {
          filterArr = [
            ...filterArr,
            {
              whereGqlType: 'min',
              create_time: new Date(this.searchForm.date[0]).getTime() / 1000,
            },
            {
              whereGqlType: 'max',
              create_time: new Date(this.searchForm.date[1]).getTime() / 1000,
            },
          ];
        }
        if (this.searchForm.sponsor) {
          filterArr = [
            ...filterArr,
            {
              whereGqlType: 'like',
              sponsor_name: `%${this.searchForm.sponsor}%`,
            },
          ];
        }
        if (this.searchForm.product_name) {
          filterArr = [
            ...filterArr,
            {
              whereGqlType: 'like',
              product_name: `%${this.searchForm.product_name}%`,
            },
          ];
        }
        if (this.searchForm.api_name) {
          filterArr = [
            ...filterArr,
            {
              whereGqlType: 'like',
              api_name: `%${this.searchForm.api_name}%`,
            },
          ];
        }
        if (this.searchForm.request) {
          filterArr = [
            ...filterArr,
            {
              whereGqlType: 'like',
              request: `%${formatStr(this.searchForm.request)}%`,
            },
          ];
        }
        // 请求列表
        const {
          audit_log: {
            _data,
            _aggregate: { count },
          },
        } = await GetArticleList({
          limit: this.pageSize,
          offset: this.pageSize * (this.page - 1),
          //   sponsor: this.searchForm.sponsor,
          filter: whereGql(filterArr),
        });
        this.total = count;
        this.list = _data.map((item) => {
          return {
            ...item,
            create_time: this.humanifyDate(item.create_time * 1000),
            delete_time: item.delete_time === 0 ? '' : this.humanifyDate(item.delete_time * 1000),
            update_time: item.update_time === 0 ? '' : this.humanifyDate(item.update_time * 1000),
            is_success: item.is_success === 1 ? '成功' : '失败',
          };
        });
        this.loading = false;
        console.log(_data);
      } catch {
        this.loading = false;
        this.list = [];
      }
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.page = 1;
      this.getList();
    },
    handleClick(row) {
      this.detail = row;
      this.$nextTick(() => {
        this.dialogVisible = true;
      });
    },
    handleClose() {
      this.dialogVisible = false;
    },
  },
};
